import _ from 'lodash';
import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from '../dummyApi';
import { times } from '../api';
const FIDP_API_ENABLED = config.servers.fidp.enabled;
const FIDP_API_URL = config.servers.fidp.url;
export interface PositionDto {
  dsdCode: string; // 도메인 코드
  code: string; // 직급 코드
  name: string; // 직금 이름
  order: number; // 직급 순서
  linkedYN: 'Y' | 'N'; // 연동 직급 여부
  updatedTime: number; // 직급 갱신 일시
}
export type PositionReqDto = Omit<PositionDto, 'code' | 'entryTs'>;
interface PositionApi {
  list(): Promise<PositionDto[]>;
}
class PositionServerApi implements PositionApi {
  async list(): Promise<PositionDto[]> {
    const resp = await axios.get<PositionDto[]>(`${FIDP_API_URL}/api/organs/positions`);
    return resp.data;
  }
}
const positionApi = new PositionServerApi();
export default positionApi;
